<script setup>
import { ref, watch } from 'vue'
import { api } from '../../services/api'

const props = defineProps({ semester: { type: Object, required: true }, subject: { type: Object, required: true } })
const emit = defineEmits(['changed', 'select'])
const form = ref({ title: '', description: '' })
const saving = ref(false)
const error = ref('')

watch(() => props.semester.id, () => { form.value = { title: '', description: '' }; error.value = '' })

async function addChapter() {
  if (saving.value) return
  saving.value = true
  error.value = ''
  try {
    const result = await api('/admin/chapters', { method: 'POST', body: JSON.stringify({ semester_id: props.semester.id, ...form.value }) })
    emit('changed', { select: `chapter-${result.id}`, message: `Đã tạo ${result.title}. Tiếp theo, thêm bài học.` })
  } catch (err) { error.value = err.message }
  finally { saving.value = false }
}
</script>

<template>
  <div class="panel-body">
    <header class="panel-head"><div><p class="eyebrow">Học kỳ</p><h2>{{ semester.title }}</h2></div></header>
    <div v-if="error" class="error-banner" role="alert">{{ error }}</div>
    <section class="panel-section">
      <div class="panel-section-head"><h3>Chương / chủ đề</h3><span>{{ semester.chapters.length }}</span></div>
      <p v-if="!semester.chapters.length" class="panel-hint">Học kỳ này chưa có chương. Thêm chương đầu tiên ở dưới.</p>
      <button v-for="(chapter, index) in semester.chapters" :key="chapter.id" type="button" class="panel-item" @click="emit('select', `chapter-${chapter.id}`)"><i>{{ String(index + 1).padStart(2, '0') }}</i><span><strong>{{ chapter.title }}</strong><small>{{ chapter.lessons.length }} bài học</small></span><b>→</b></button>
    </section>
    <form class="panel-section panel-form" @submit.prevent="addChapter">
      <div class="panel-section-head"><h3>＋ Thêm chương / chủ đề</h3></div>
      <div class="form-group"><label for="chapter-title">Tên chương</label><input id="chapter-title" v-model="form.title" class="form-control" required maxlength="180" :disabled="saving" placeholder="Ví dụ: Chương 1. Tập hợp các số tự nhiên"></div>
      <div class="form-group"><label for="chapter-description">Mô tả</label><textarea id="chapter-description" v-model="form.description" class="form-control" :disabled="saving"></textarea></div>
      <button class="btn btn-primary" :disabled="saving">{{ saving ? 'Đang tạo…' : 'Thêm chương' }}</button>
    </form>
  </div>
</template>
